import axios from 'axios'
import { getCartSectionsToRender } from '../utils/get-sections'

/**
 * Adds support for BG Cache with section rendering.
 */
export const enableBFCacheSupport = () => {
  // add event listeren to pageshow event.
  window.addEventListener('pageshow', (event) => {
    // Check if the page was loaded from cache.
    if (event.persisted) {
      // Get current url with params.
      const url = new URL(window.location.href)
      url.searchParams.append('sections', getCartSectionsToRender().map((section) => section.id).join(','))

      // Get the rendered sections from the server.
      axios.get(url.href).then((response) => {
        const newRenderedSectionsObject = response.data
        const sectionObjects = Object.keys(newRenderedSectionsObject).map(key => ({
          name: key,
          html: newRenderedSectionsObject[key],
        }))

        // Loop over all the sections returned from the section rendering endpoint.
        sectionObjects.forEach((renderedSection) => {
          const parser = new DOMParser()
          const destinationSelector = getCartSectionsToRender().find((sectionInfo) => sectionInfo.id == renderedSection.name)?.selector
          const destinationElement = document.querySelector(destinationSelector)
          const rawSectionData = parser.parseFromString(renderedSection.html, 'text/html')
          const newSectionElement = rawSectionData.querySelector(destinationSelector)

          // If there is a destionation element, replace the content with the new content.
          if (destinationElement) {
            destinationElement.innerHTML = newSectionElement.innerHTML
          }
        })
      })
    }
  }, false, { passive: true })
}